import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Vehicle damage notification context enum
 * @description Notification contexts specific to vehicle damage subjects
 */
export enum VehicleDamageNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Vehicle damage-specific contexts
	PENDING = 'pending',
	REPAIRED = 'repaired',
	IGNORED = 'ignored',
}
